import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'common-weight-height',
  templateUrl: './weight-height.component.html',
  styleUrls: ['./weight-height.component.less'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class WeightHeightComponent implements OnInit {
  @Input() data;
  @Input() showLabel: boolean;
  @Input() editMode = true;
  weight = {
    value: {
      type: 'number',
      name: 'weight',
      size: 'large',
      placeholder: 'weight',
      required: true
    },
    unit: {
      type: 'dropdown',
      name: 'weightUnit',
      options: [
        { key: 'lbs', value: 'lbs' },
        { key: 'kilograms', value: 'kilograms' }
      ],
      placeholder: 'unit',
      size: 'large',
      required: true
    }
  };
  height = {
    value: {
      type: 'number',
      name: 'height',
      size: 'large',
      required: true
    },
    unit: {
      type: 'dropdown',
      name: 'heightUnit',
      options: [
        { key: 'feetIn', value: 'feet(+in)' },
        { key: 'centimeters', value: 'centimeters' }
      ],
      placeholder: 'unit',
      size: 'large',
      disabled: true,
      required: true
    }
  };
  division = '&mdash;';

  constructor() {}

  ngOnInit(): void {}

  get heightAnswerValue() {
    const selectedUnit = this.data[this.height.unit.name];
    return {
      ...this.height.value,
      placeholder:
        selectedUnit === 'feetIn'
          ? 'feet'
          : selectedUnit
          ? selectedUnit
          : this.height.value.name
    };
  }

  handleChildChange() {
    if (this.data['weightUnit'] === 'lbs') {
      this.data['heightUnit'] = 'feetIn';
    } else {
      this.data['heightUnit'] = 'centimeters';
    }
  }
}
